var React = require('react');

function Location (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 4.86695C10 8.61345 5 14.2857 5 14.2857C5 14.2857 2.56595 11.5313 1.10312 8.5901C0.455635 7.30626 0 5.99907 0 4.86695C0 2.18254 2.24221 0 5 0C7.75779 0 10 2.18254 10 4.86695Z","fill":"white"}));
}

Location.defaultProps = {"width":"10","height":"15","viewBox":"0 0 10 15","fill":"none"};

module.exports = Location;

Location.default = Location;
